import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/Ft.webp'


const _hoisted_1 = { class: "get-app-sheet" }

import { Icon } from '@iconify/vue';
import '@/assets/styles/GetAppBottomSheet.css';

// Using a placeholder image if the specific asset isn't available
// You might want to replace this with the actual image path
const defaultImage = 'https://placehold.co/200x400/png?text=App+Preview';


export default /*@__PURE__*/_defineComponent({
  __name: 'GetAppBottomSheet',
  props: {
    show: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const closeSheet = () => {
    emit('close');
};

const handleGetApp = () => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    if (/android/i.test(userAgent)) {
        // Android - Open Play Store
        window.open('https://play.google.com/store/apps/details?id=com.ScanbCard.smartcard_app', '_blank');
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
        // iOS - Open App Store
        window.open('https://apps.apple.com/us/app/smartcard-qr-business-card/id1541370437', '_blank');
    } else {
        // Web or other
        window.open('https://qwiku.com', '_blank');
    }
    closeSheet();
};

const handleImageError = (e: Event) => {
    (e.target as HTMLImageElement).src = defaultImage;
};

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "get-app-overlay",
        onClick: _withModifiers(closeSheet, ["self"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "close-btn",
            onClick: closeSheet,
            "aria-label": "Close"
          }, [
            _createVNode(_unref(Icon), {
              icon: "mdi:close",
              width: "20",
              height: "20"
            })
          ]),
          _createElementVNode("img", {
            src: _imports_0,
            alt: "App Preview",
            class: "phone-mockup",
            onError: handleImageError
          }, null, 32),
          _createElementVNode("div", { class: "content-section" }, [
            _cache[0] || (_cache[0] = _createElementVNode("h2", null, "QwikU", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Digital Business Card", -1)),
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "subtitle" }, " Show, Don't Just Tell. ", -1)),
            _createElementVNode("button", {
              class: "get-app-btn",
              onClick: handleGetApp
            }, " Get the app ")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})